import z from 'zod'

export const contentTypeFiltersSchema = z.record(
  z.string(),
  z.string().or(z.array(z.string())),
)

export type ContentTypeFiltersForm = z.infer<typeof contentTypeFiltersSchema>
